import { useEffect, useState } from 'react';
import {
  Button,
  Card,
  Select,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Layout,
  Typography,
  Spin,
  Table,
  Checkbox,
  notification,
  TableProps,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import useHandbook from '@hooks/useHandbook';
import dayjs from 'dayjs';
import TreeSelectHandbook from '@modules/TreeSelect/TreeSelectHandook';
import DateMask from '@modules/Edo/DateMask';
import CustomLoader from '@components/UI/CustomLoader/CustomLoader';
import { getDocData } from '@modules/Agreement/getDocData';
import api from '@modules/Quotation/services';
import useAuth from '@hooks/useAuth';
import axios from 'axios';
const { Content } = Layout;
const { Title } = Typography;

interface Props {
  title: string;
}
type Action = {
  type: 'settings' | 'loadingSettings';
  payload?: any;
};

interface State {
  doc_formular: any;
  data_docrow: any;
  data_addatr: any;
  isLoading: boolean;
  contractID: string | null;
  contract: string | null;
}

const initialState: State = {
  doc_formular: null,
  data_docrow: null,
  data_addatr: null,
  isLoading: false,
  contractID: null,
  contract: null,
};

const reducer = (draft = initialState, action: Action) => {
  switch (action.type) {
    case 'settings': {
      draft.doc_formular = action.payload.doc_formular;
      draft.data_docrow = action.payload.data_docrow;
      draft.data_addatr = action.payload.data_addatr;
      draft.contractID = action.payload.contract_id;
      draft.contract = action.payload.contract;
      break;
    }
    case 'loadingSettings': {
      draft.isLoading = action.payload;
      break;
    }
    default:
      throw new Error(`Unknown action type: ${action.type}`);
  }
};
const { Option } = Select;

function GenContract({ title = 'Mycent.kz' }: Props) {
  const [state, dispatch] = useImmerReducer(reducer, initialState);
  const {
    doc_formular,
    data_docrow,
    data_addatr,
    isLoading,
    contractID,
    contract,
  } = state;
  const [formularForm] = Form.useForm();
  const navigate = useNavigate();
  const auth = useAuth();
  const [tabularForm] = Form.useForm();
  const { handbookList, isLoadingHandbookList } = useHandbook('cDocClass');
  const { id } = useParams();
  const [isCreatingNewContract, setIsCreatingNewContract] = useState(false);
  const [selectedContract, setSelectedContract] = useState<any>(null);
  const [checkedData, setCheckedData] = useState(
    data_docrow?.map((item) => {
      return {
        ...item,
        isChecked: false,
      };
    })
  );

  const onChangeCheckbox = (val, data) => {
    setCheckedData(
      checkedData.map((item) => {
        if (item.isn === data.isn) {
          return {
            ...item,
            isChecked: true,
          };
        } else {
          return item;
        }
      })
    );
  };
  const createGenDocAgr = async () => {
    try {
      setIsCreatingNewContract(true);
      const { data } = await api.quotation.createGenDocAgr({
        pDocISN: id,
        pUserISN: auth?.user?.data?.user_info?.foreign_id,
      });
      let parsedData = JSON.parse(data.data);
      if (parsedData.agreement) {
        navigate(`/contract/${parsedData.agreement[0].isn}`);
      } else if (parsedData.agreementcalc) {
        navigate(`/quotation/${parsedData.agreementcalc[0].quotation_id}`);
      }
      setIsCreatingNewContract(false);
    } catch (error) {
      let message;

      if (axios.isAxiosError(error) && error.response) {
        message = error.response.data.message;
      } else {
        message = String(error);
      }

      notification.info({
        message: 'Ошибка',
        description: message,
      });
      setIsCreatingNewContract(false);
    }
  };
  const copyContract = async () => {
    if (selectedContract !== null) {
      try {
        setIsCreatingNewContract(true);
        const { data } = await api.quotation.createGenDocAgr({
          pDocISN: id,
          pAgrISN: selectedContract[0],
          pUserISN: auth?.user?.data?.user_info?.foreign_id,
        });
        let parsedData = JSON.parse(data.data);
        if (parsedData.agreement) {
          navigate(`/contract/${parsedData.agreement[0].isn}`);
        } else if (parsedData.agreementcalc) {
          navigate(`/quotation/${parsedData.agreementcalc[0].quotation_id}`);
        }
        setIsCreatingNewContract(false);
      } catch (error) {
        let message;

        if (axios.isAxiosError(error) && error.response) {
          message = error.response.data.message;
        } else {
          message = String(error);
        }

        notification.info({
          message: 'Ошибка',
          description: message,
        });
        setIsCreatingNewContract(false);
      }
    } else {
      notification.info({
        message: 'Ошибка',
        description: 'Выберите договор!',
      });
    }
  };
  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows) => {
      setSelectedContract(selectedRowKeys);
    },
  };

  const columns = [
    {
      title: 'Договор',
      dataIndex: 'id',
      key: 'id',
      width: '15%',
    },
    {
      title: 'Статус',
      dataIndex: 'status',
      key: 'status',
      width: '10%',
    },
    {
      title: 'Подписан',
      dataIndex: 'datesign',
      key: 'datesign',
      width: '10%',
    },
    {
      title: 'Начало',
      dataIndex: 'datebeg',
      key: 'datebeg',
      width: '10%',
    },
    {
      title: 'Окончание',
      dataIndex: 'dateend',
      key: 'dateend',
      width: '10%',
    },
    {
      title: 'Прекращения',
      dataIndex: 'datedenounce',
      key: 'datedenounce',
      width: '10%',
    },
    {
      title: 'Валюта',
      dataIndex: 'currisn',
      key: 'currisn',
      width: '10%',
    },
    {
      title: 'Премия',
      dataIndex: 'premiumsum',
      key: 'premiumsum',
      width: '10%',
    },
    {
      title: 'Оплачено',
      dataIndex: 'factprem',
      key: 'factprem',
      width: '10%',
    },
    {
      title: 'Продукт',
      dataIndex: 'productisn',
      key: 'productisn',
      width: '10%',
    },
    {
      title: 'Страхователь',
      dataIndex: 'clientisn',
      key: 'clientisn',
      width: '10%',
    },
    {
      title: 'Куратор',
      dataIndex: 'emplisn',
      key: 'emplisn',
      width: '10%',
    },
    {
      title: 'Подразделение',
      dataIndex: 'deptisn',
      key: 'deptisn',
      width: '10%',
    },
  ];

  const fetchData = async (id) => {
    try {
      dispatch({ type: 'loadingSettings', payload: true });
      await getDocData(id).then((values) => {
        if (data_docrow === null) {
          dispatch({
            type: 'settings',
            payload: {
              doc_formular: values.Docs.docform,
              doc_row: values.Docs.row_headers,
              data_docrow: values.Docs.rows,
            },
          });
        }
      });
    } catch (error) {
      console.log(error);
    } finally {
      dispatch({ type: 'loadingSettings', payload: false });
    }
  };
  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(() => {
    /*
      Просмотр документа
      Получаем данные документа и настройки домукента
    */
    if (id) {
      fetchData(id);
    }
  }, [id]);

  if (isLoadingHandbookList) {
    return <CustomLoader />;
  } else {
    if (!isLoading) {
      DateMask();
    }
  }
  return (
    <>
      <Form.Provider>
        <CustomLoader spinning={isLoading}>
          <Content data-testid="edo-content">
            <Card>
              <Title
                data-testid="edo-title"
                level={5}
                type="secondary"
                className="mb-5"
              >
                Ген.договор
              </Title>
              <Form
                layout="vertical"
                name="documentForm"
                form={formularForm}
                // onFinish={handleDocumentCreate}
              >
                <Row gutter={24} align="bottom">
                  {doc_formular
                    ?.filter((item) => Number(item.field_hidden) === 0)
                    .map((field) => {
                      return (
                        <Col span={8} xs={24} xl={8}>
                          <Form.Item
                            label={field.field_name}
                            name={field.field_id}
                            hidden={Number(field.field_hidden) === 1}
                            initialValue={field.field_value_name}
                          >
                            <Input value={field.field_value_name} disabled />
                          </Form.Item>
                        </Col>
                      );
                    })}
                </Row>
              </Form>
            </Card>
            <Card style={{ marginTop: '30px' }}>
              <Title
                data-testid="edo-title"
                level={5}
                type="secondary"
                className="mb-5"
              >
                Табличная часть
              </Title>
              <Spin spinning={isLoading || isCreatingNewContract}>
                <Button
                  type="primary"
                  className="mt-3 mr-3 mb-3"
                  onClick={createGenDocAgr}
                >
                  Новый договор
                </Button>
                <Button className="mt-3 mb-3" onClick={copyContract}>
                  Копировать договор
                </Button>
                <Table
                  rowKey={(record) => record.isn}
                  rowSelection={{ type: 'radio', ...rowSelection }}
                  columns={columns}
                  dataSource={data_docrow}
                  scroll={{ x: 'max-content' }}
                />
              </Spin>
            </Card>
          </Content>
        </CustomLoader>
      </Form.Provider>
    </>
  );
}

export default GenContract;
